import React from "react";
// css comes in hw_master.css

const QuestionThreeDotPopup = ({ setQuestions, questionIndex }) => {
  const removeQuestion = () => {
    setQuestions((prev) => {
      const newQuestion = prev.filter((_, i) => i !== questionIndex);
      return newQuestion;
    });
  };
  return (
    <>
      <div className=" p-3 main_card_popup_box ">
        <button onClick={removeQuestion} className="main_card_popup_button">
          Delete
        </button>
      </div>
    </>
  );
};

export default QuestionThreeDotPopup;
